import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { SEOSpaceLocal } from 'src/common/config/TextMessage';

const isLocalSeo = isLocalSeoUser() || null;
export const BackLinkAllTexts = {
  noDataFound: 'No Backlinks Found',
  backLinkTitle: 'Backlink Analysis:',
  exportToCSV: 'Export to CSV',
  options: [
    { label: 'Do Follow', value: 'dofollow' },
    { label: 'No Follow', value: 'nofollow' }
  ],
  otherTools: 'Other Tools',
  backLinkAnalysis: 'Backlink Analysis',
  backLinkAnalysisTutorial: 'Confused about backlinks? Watch this Guide.',
  exploreReferringPages: 'View All Backlinks',
  search: 'Search',
  enterWebSite: 'Enter a website to get started',
  backLinkTooltip:
    'A backlink is a hyperlink from one website to another; like when someone links to your site in a blog post or article. This feature shows which websites link to you (or any site). Google treats these links as votes of confidence or social proof. The more high-quality backlinks you have, the more trust your site earns, and the better your chances of ranking for competitive keywords.',
  noUrlError: 'Website URL is required',
  validUrlError: 'Please enter a valid URL',
  getMoreBacklinks: 'Get More Backlinks',
  backlinkAttrImageTooltip:
    'This backlink is from an image on the linking page',
  backlinkAttrContentTooltip:
    'This backlink is linked in the text content on the linking page',
  attrType: {
    image: 'IMAGE',
    content: 'CONTENT'
  },
  filtersOptions: [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  unlock: 'Unlock Backlink Analysis Tools',
  unlockDesc:
    'Access SEOSpace’s Backlink Analysis Tool by upgrading to SEOSpace’s Expert plan or selecting our Backlink Analysis Add-On.',
  organicTrafficTooltip:
    '- this is the estimated monthly traffic this website receives from Google globally.',
  loadMore: 'Load 1,000 More'
};

export const backLinkTooltips = [
  "This is the exact page on another website that links to your entered site. It's normal to see a mix of helpful and spammy pages here.",
  'DA is a score given to a website that deems how much of an “authority” it is on the internet - the more high quality backlinks, the higher the DA and more likely the site is to rank for competitive keywords.',
  'Spam Score estimates how risky or low-quality a linking site might be. Don’t worry — most sites have some spammy links, and Google doesn’t punish you just for that. Check the',
  'This shows the exact text used in the link (anchor text), and the page on your site that it links to (target URL).',
  'Links can be ‘dofollow’ or ‘nofollow’. Dofollow links pass SEO value to your site — they count as a signal to Google. Nofollow links don’t pass value, but they can still bring traffic.',
  'This is the date the backlink was first detected. It shows when the link to your site was first found.',
  'The shows whether the backlink has been lost or not. A backlink might be "lost" because it was removed, or it could be a temporary issue, like a crawling error.'
];

export const backLinkDrOptions = ['0', '1-25', '26-50', '51-75', '76-100'];
//export const backLinkSpamScoreOptions = ['1-10', '20-50', '50-100'];
export const backLinkSpamScoreOptions = [
  '0% to 30%',
  '31% to 60%',
  '61% to 100%'
];

export const LocalSeoInfoBoxTexts = {
  mainDesc:
    '46% of Google Searches Are Local. Be The Business They Find First.',
  subDesc:
    "Get discovered by nearby customers looking for your product or service using SEOSpace's Local SEO tools.",
  learnMoreAboutLocalSEO: `Learn More About ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  }`,
  watchYouTubeVideo: 'Upgrade Now',
  dontHaveAccount: "Don't Have a Google Business Profile? ",
  setItUpNow: 'Set It Up Now',
  seoToolsLink: 'https://www.seospace.co/local-seo-tools'
};
